import i18n from '../i18n';

// Map the active i18n language to a BCP-47 locale for Intl date formatting.
// European day-month-year ordering is kept across all three locales.
const INTL_LOCALES = { fr: 'fr-FR', en: 'en-GB', es: 'es-ES' };

const intlLocale = () => INTL_LOCALES[i18n.language] || INTL_LOCALES.fr;

// Locale-aware date formatter. Reads the active locale at call time, so dates
// reformat when the language changes (callers re-render via react-i18next).
export const formatDate = (dateString, options) =>
  new Date(dateString).toLocaleDateString(intlLocale(), options);

export const formatDateTime = (dateString) =>
  new Date(dateString).toLocaleString(intlLocale());
